import {abilityFeature} from '../abilityFeature';

export const userTypes = abilityFeature({
  key: 'userTypes',
  isValid: function isUserTypesValid(state, config) {
    const currentUserType = state.DesignerStore.userType;

    return Boolean(config[currentUserType]);
  },
});
